import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { getWhatsAppLink } from '../utils/whatsapp';
const FOOTER_WHATSAPP_MESSAGE = 'Hola, equipo de Origen Studio. Quiero conocer más sobre sus sistemas de presencia digital y automatización con IA.';
export function Footer() {
  return <footer className="bg-carbon text-arena pt-12 md:pt-16 px-6 md:px-20 pb-12 md:pb-16" data-id="element-79" data-mp="36qhh702ou83u">
      <div className="max-w-[1200px] mx-auto" data-id="element-80" data-mp="3uesclnpm7fkq">
        <div className="flex flex-col md:flex-row justify-between gap-12 md:gap-24 mb-16" data-id="element-81" data-mp="3ucxndx7b91au">
          {/* Left Column */}
          <div className="flex-1" data-id="element-82" data-mp="3lec9wggp4cgx">
            <div className="mb-4" data-id="element-83" data-mp="3ldanjfu8c3jw">
              <Logo variant="dark" data-id="element-84" data-mp="3lggc8tyy53f3" />
            </div>
            <p className="font-body text-[14px] text-arena/55 max-w-[360px] leading-relaxed" data-id="element-85" data-mp="3qcnjcq32wkym">
              Presencia digital · IA · Automatización
            </p>
          </div>

          {/* Right Column */}
          <div className="flex-1 md:max-w-[400px]" data-id="element-86" data-mp="2ezbf4e3eq0bx">
            <div className="flex flex-wrap gap-x-6 gap-y-4" data-id="element-87" data-mp="3l9k65dxrvpdt">
              <a href="#sistema" className="font-body text-[13px] text-arena/50 hover:text-arena/100 transition-opacity duration-150 no-underline" data-id="element-88" data-mp="3la28msb12zu6">
                Sistema
              </a>
              <a href="#precios" className="font-body text-[13px] text-arena/50 hover:text-arena/100 transition-opacity duration-150 no-underline" data-id="element-89" data-mp="3q8mz400ha55f">
                Precios
              </a>
              <Link to="/diagnostico" className="font-body text-[13px] text-arena/50 hover:text-arena/100 transition-opacity duration-150 no-underline" data-id="element-90" data-mp="32w1tqajr697">
                Diagnóstico ICD™
              </Link>
              <a href={getWhatsAppLink(FOOTER_WHATSAPP_MESSAGE)} target="_blank" rel="noopener noreferrer" className="font-body text-[13px] text-arena/50 hover:text-arena/100 transition-opacity duration-150 no-underline" data-id="element-91" data-mp="cw3617tjwg7p">
                WhatsApp
              </a>
              <a href="https://www.instagram.com/origenstudioco?igsh=MTN0bWcyY2Y2YXEzaQ%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="font-body text-[13px] text-arena/50 hover:text-arena/100 transition-opacity duration-150 no-underline" data-id="element-92" data-mp="yv93xsa5fyv8">
                Instagram
              </a>
              <a href="mailto:hola@origenstudioco.com" className="font-body text-[13px] text-arena/50 hover:text-arena/100 transition-opacity duration-150 no-underline" data-id="element-93" data-mp="1hjw888ki4k7r">
                hola@origenstudioco.com
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Line */}
        <div className="pt-6 border-t border-arena/10" data-id="element-94" data-mp="3od841810vwjv">
          <p className="font-body text-[12px] text-arena/30" data-id="element-95" data-mp="3t9gguerqzdnv">
            © 2025 Origen Studio · Colombia
          </p>
        </div>
      </div>
    </footer>;
}